import { createContext, useContext } from 'react';

const ChatContext = createContext({ openWithMessage: () => {} });

export const useChatContext = () => useContext(ChatContext);
export default ChatContext;
